import * as THREE from 'three';
import { PuzzleElement } from './PuzzleElement';

export class PressurePlate extends PuzzleElement {
  private isPressed: boolean = false;
  private triggerRadius: number = 1;
  private onActivate: (() => void) | null = null;
  private onDeactivate: (() => void) | null = null;
  private requiresWeight: boolean = false; // Requires Ares mask or pushed block
  
  constructor(
    position: THREE.Vector3, 
    requiresWeight: boolean = false,
    onActivate?: () => void,
    onDeactivate?: () => void
  ) {
    super(position);
    this.requiresWeight = requiresWeight;
    this.onActivate = onActivate || null;
    this.onDeactivate = onDeactivate || null;
  }
  
  protected createMesh(): THREE.Mesh {
    const geometry = new THREE.CylinderGeometry(0.8, 0.8, 0.1, 16);
    const material = new THREE.MeshStandardMaterial({ 
      color: 0x888888,
      roughness: 0.5,
      metalness: 0.5
    });
    
    const mesh = new THREE.Mesh(geometry, material);
    mesh.receiveShadow = true;
    
    return mesh;
  }
  
  public update(deltaTime: number, playerPosition: THREE.Vector3): void {
    const distance = new THREE.Vector2(
      playerPosition.x - this.position.x,
      playerPosition.z - this.position.z
    ).length();
    
    const wasPressed = this.isPressed;
    this.isPressed = distance < this.triggerRadius;
    
    // Update visual
    const targetY = this.isPressed ? this.position.y - 0.05 : this.position.y;
    this.mesh.position.y += (targetY - this.mesh.position.y) * 0.2;
    
    // Update color
    ((this.mesh as THREE.Mesh).material as THREE.MeshStandardMaterial).color.setHex(
      this.isPressed ? 0x44ff44 : 0x888888
    );
    
    // Fire callbacks
    if (this.isPressed && !wasPressed) {
      this.onActivate?.();
    } else if (!this.isPressed && wasPressed) {
      this.onDeactivate?.();
    }
  }
  
  public isPressedState(): boolean {
    return this.isPressed;
  }
  
  public setCallbacks(onActivate: () => void, onDeactivate: () => void): void {
    this.onActivate = onActivate;
    this.onDeactivate = onDeactivate;
  }
}
